import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import styles from "./StatsCardSummary.module.css";
export const StatsCardSummary = ({ title, total, className, onClick, circleVariant = "default", }) => {
    const content = (_jsxs(_Fragment, { children: [_jsx("h3", { className: styles.title, children: title }), _jsx("div", { className: clsx(styles.totalCircle, circleVariant === "yellow" && styles.totalCircleYellow), children: _jsx("span", { className: styles.totalValue, children: total }) })] }));
    if (onClick) {
        return (_jsx("div", { className: clsx(styles.container, styles.clickable, className), role: "button", tabIndex: 0, onClick: onClick, onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                }
            }, children: content }));
    }
    return _jsx("div", { className: clsx(styles.container, className), children: content });
};
